import { createApiClient } from "../client";
import { common } from "../rpc/api";
import { getToken } from "./bind_token";

export const getFileDownloadURL = async (gsURL: string): Promise<string> => {
  const token = await getToken();
  const body = common.TextResult.encode({ result: gsURL }).finish();
  const response = await createApiClient().postWithToken(
    "/api.UserService/GetFileDownloadURL",
    token,
    body
  );
  return common.TextResult.decode(response).result;
};



// WEBPACK FOOTER //
// ./src/infra/api/service/resource_api.ts